export type KitchensinkPageMeta = {
  slug: string
  label: string
  /** SPA route path (react-router) */
  spaPath: string
  /** MPA URL — directory-style with trailing slash, one real HTML page each */
  mpaPath: string
}

export const KITCHENSINK_PAGES: readonly KitchensinkPageMeta[] = [
  { slug: 'home', label: 'Home', spaPath: '/home', mpaPath: '/' },
  { slug: 'page-a', label: 'Page A', spaPath: '/page-a', mpaPath: '/page-a/' },
  { slug: 'page-b', label: 'Page B', spaPath: '/page-b', mpaPath: '/page-b/' },
  { slug: 'email', label: 'Email Tracking', spaPath: '/email', mpaPath: '/email/' },
  { slug: 'engagement', label: 'Engagement', spaPath: '/engagement', mpaPath: '/engagement/' },
  {
    slug: 'file-download',
    label: 'File Download',
    spaPath: '/file-download',
    mpaPath: '/file-download/',
  },
  {
    slug: 'tracking-toggle',
    label: 'Tracking Toggle',
    spaPath: '/tracking-toggle',
    mpaPath: '/tracking-toggle/',
  },
  {
    slug: 'product-impression',
    label: 'Product Impression',
    spaPath: '/product-impression',
    mpaPath: '/product-impression/',
  },
  { slug: 'event-queue', label: 'Event Queue', spaPath: '/event-queue', mpaPath: '/event-queue/' },
  { slug: 'click-ids', label: 'Ad Click IDs', spaPath: '/click-ids', mpaPath: '/click-ids/' },
  { slug: 'consent', label: 'Consent', spaPath: '/consent', mpaPath: '/consent/' },
  { slug: 'reinit', label: 'Re-init', spaPath: '/reinit', mpaPath: '/reinit/' },
  { slug: 'liftai', label: 'LiftAi', spaPath: '/liftai', mpaPath: '/liftai/' },
]
